import { TestDefinition, QuestionType } from '../../types';

// Helper scales
const vanderbiltFrequency = [
  { label: 'Never', value: 0 },
  { label: 'Occasionally', value: 1 },
  { label: 'Often', value: 2 },
  { label: 'Very Often', value: 3 }
];

const vanderbiltPerformance = [
  { label: 'Excellent', value: 1 },
  { label: 'Above Average', value: 2 },
  { label: 'Average', value: 3 },
  { label: 'Somewhat Problematic', value: 4 },
  { label: 'Problematic', value: 5 }
];

const sdqScale = [
  { label: 'Not True', value: 0 },
  { label: 'Somewhat True', value: 1 },
  { label: 'Certainly True', value: 2 }
];

const asrsScale = [
  { label: 'Never', value: 0 },
  { label: 'Rarely', value: 1 },
  { label: 'Sometimes', value: 2 },
  { label: 'Often', value: 3 },
  { label: 'Very Often', value: 4 }
];

export const TESTS_PEDIATRICO_TDAH: TestDefinition[] = [
  {
    id: 'vanderbilt-parent',
    code: 'Vanderbilt-P',
    name: 'Vanderbilt ADHD Parent Rating Scale (Brief Version)',
    category: 'ADHD / Pediatric',
    description: 'A 27-item scale for ADHD screening in children ages 6-12. Completed by parents. Assesses symptoms of inattention, hyperactivity and impulsivity according to DSM criteria.',
    questions: [
      // INATTENTION (9 items)
      {
        id: 'v1',
        text: '1. Does not pay attention to details or makes careless mistakes',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inattention'
      },
      {
        id: 'v2',
        text: '2. Has difficulty sustaining attention in tasks',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inattention'
      },
      {
        id: 'v3',
        text: '3. Does not seem to listen when spoken to directly',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inattention'
      },
      {
        id: 'v4',
        text: '4. Does not follow through on instructions and fails to finish schoolwork',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inattention'
      },
      {
        id: 'v5',
        text: '5. Has difficulty organizing tasks and activities',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inattention'
      },
      {
        id: 'v6',
        text: '6. Avoids tasks that require sustained mental effort',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inattention'
      },
      {
        id: 'v7',
        text: '7. Loses things necessary for tasks or activities',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inattention'
      },
      {
        id: 'v8',
        text: '8. Is easily distracted by irrelevant stimuli',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inattention'
      },
      {
        id: 'v9',
        text: '9. Is forgetful in daily activities',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inattention'
      },

      // HYPERACTIVITY/IMPULSIVITY (9 items)
      {
        id: 'v10',
        text: '10. Fidgets with hands or feet or squirms in seat',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hyperactivity/Impulsivity'
      },
      {
        id: 'v11',
        text: '11. Leaves seat when remaining seated is expected',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hyperactivity/Impulsivity'
      },
      {
        id: 'v12',
        text: '12. Runs or climbs in inappropriate situations',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hyperactivity/Impulsivity'
      },
      {
        id: 'v13',
        text: '13. Has difficulty playing quietly',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hyperactivity/Impulsivity'
      },
      {
        id: 'v14',
        text: '14. Is "on the go" or acts as if "driven by a motor"',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hyperactivity/Impulsivity'
      },
      {
        id: 'v15',
        text: '15. Talks excessively',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hyperactivity/Impulsivity'
      },
      {
        id: 'v16',
        text: '16. Blurts out answers before questions have been completed',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hyperactivity/Impulsivity'
      },
      {
        id: 'v17',
        text: '17. Has difficulty waiting turn',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hyperactivity/Impulsivity'
      },
      {
        id: 'v18',
        text: '18. Interrupts or intrudes on others',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hyperactivity/Impulsivity'
      },

      // ACADEMIC PERFORMANCE (8 items)
      {
        id: 'v19',
        text: '19. Performance in reading',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Academic Performance'
      },
      {
        id: 'v20',
        text: '20. Performance in mathematics',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Academic Performance'
      },
      {
        id: 'v21',
        text: '21. Performance in writing',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Academic Performance'
      },
      {
        id: 'v22',
        text: '22. Relationship with peers',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Social Performance'
      },
      {
        id: 'v23',
        text: '23. Participation in organized activities',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Social Performance'
      },
      {
        id: 'v24',
        text: '24. Following directions at home',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Home Performance'
      },
      {
        id: 'v25',
        text: '25. Relationship with parents',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Home Performance'
      },
      {
        id: 'v26',
        text: '26. Relationship with siblings',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Home Performance'
      },
      {
        id: 'v27',
        text: '27. Assigned responsibilities at home',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Home Performance'
      }
    ],
    subscales: [
      {
        name: 'Inattention',
        questionIds: ['v1', 'v2', 'v3', 'v4', 'v5', 'v6', 'v7', 'v8', 'v9'],
        description: 'Attention deficit symptoms (≥6 items with 2-3 suggests inattentive ADHD)'
      },
      {
        name: 'Hyperactivity/Impulsivity',
        questionIds: ['v10', 'v11', 'v12', 'v13', 'v14', 'v15', 'v16', 'v17', 'v18'],
        description: 'Hyperactivity and impulsivity symptoms (≥6 items with 2-3 suggests hyperactive ADHD)'
      },
      {
        name: 'Academic Performance',
        questionIds: ['v19', 'v20', 'v21'],
        description: 'Functioning in academic areas'
      },
      {
        name: 'Social Performance',
        questionIds: ['v22', 'v23'],
        description: 'Social functioning with peers'
      },
      {
        name: 'Home Performance',
        questionIds: ['v24', 'v25', 'v26', 'v27'],
        description: 'Functioning at home'
      }
    ],
    interpretations: [
      { min: 0, max: 18, label: 'Low ADHD Symptoms', color: 'bg-green-100 text-green-800' },
      { min: 19, max: 36, label: 'Mild ADHD Symptoms', color: 'bg-yellow-100 text-yellow-800' },
      { min: 37, max: 54, label: 'Moderate ADHD Symptoms - Evaluation Required', color: 'bg-orange-100 text-orange-800' },
      { min: 55, max: 81, label: 'Severe ADHD Symptoms - Urgent Evaluation', color: 'bg-red-200 text-red-900' }
    ]
  },
  {
    id: 'sdq',
    code: 'SDQ',
    name: 'Strengths and Difficulties Questionnaire',
    category: 'ADHD / Pediatric',
    description: 'A 25-item questionnaire for screening child psychopathology (ages 4-17). Developed by Goodman (1997). Assesses 5 dimensions: emotional symptoms, conduct problems, hyperactivity, peer problems and prosocial behavior.',
    questions: [
      // EMOTIONAL SYMPTOMS (5 items)
      {
        id: 's1',
        text: '1. Often complains of headaches, stomach-aches or sickness',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Emotional Symptoms'
      },
      {
        id: 's2',
        text: '2. Many worries or often seems worried',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Emotional Symptoms'
      },
      {
        id: 's3',
        text: '3. Often unhappy, downhearted or tearful',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Emotional Symptoms'
      },
      {
        id: 's4',
        text: '4. Nervous or clingy in new situations, easily loses confidence',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Emotional Symptoms'
      },
      {
        id: 's5',
        text: '5. Many fears, easily scared',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Emotional Symptoms'
      },

      // CONDUCT PROBLEMS (5 items)
      {
        id: 's6',
        text: '6. Often has temper tantrums or hot tempers',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Conduct Problems'
      },
      {
        id: 's7',
        text: '7. Generally obedient, usually does what adults request',
        type: QuestionType.LIKERT,
        options: [
          { label: 'Not True', value: 2 },
          { label: 'Somewhat True', value: 1 },
          { label: 'Certainly True', value: 0 }
        ],
        subscale: 'Conduct Problems'
      },
      {
        id: 's8',
        text: '8. Often fights with other children or bullies them',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Conduct Problems'
      },
      {
        id: 's9',
        text: '9. Often lies or cheats',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Conduct Problems'
      },
      {
        id: 's10',
        text: '10. Steals from home, school or elsewhere',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Conduct Problems'
      },

      // HYPERACTIVITY (5 items)
      {
        id: 's11',
        text: '11. Restless, overactive, cannot stay still for long',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Hyperactivity'
      },
      {
        id: 's12',
        text: '12. Constantly fidgeting or squirming',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Hyperactivity'
      },
      {
        id: 's13',
        text: '13. Easily distracted, concentration wanders',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Hyperactivity'
      },
      {
        id: 's14',
        text: '14. Thinks things out before acting',
        type: QuestionType.LIKERT,
        options: [
          { label: 'Not True', value: 2 },
          { label: 'Somewhat True', value: 1 },
          { label: 'Certainly True', value: 0 }
        ],
        subscale: 'Hyperactivity'
      },
      {
        id: 's15',
        text: '15. Sees tasks through to the end, good attention span',
        type: QuestionType.LIKERT,
        options: [
          { label: 'Not True', value: 2 },
          { label: 'Somewhat True', value: 1 },
          { label: 'Certainly True', value: 0 }
        ],
        subscale: 'Hyperactivity'
      },

      // PEER PROBLEMS (5 items)
      {
        id: 's16',
        text: '16. Rather solitary, tends to play alone',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Peer Problems'
      },
      {
        id: 's17',
        text: '17. Has at least one good friend',
        type: QuestionType.LIKERT,
        options: [
          { label: 'Not True', value: 2 },
          { label: 'Somewhat True', value: 1 },
          { label: 'Certainly True', value: 0 }
        ],
        subscale: 'Peer Problems'
      },
      {
        id: 's18',
        text: '18. Generally liked by other children',
        type: QuestionType.LIKERT,
        options: [
          { label: 'Not True', value: 2 },
          { label: 'Somewhat True', value: 1 },
          { label: 'Certainly True', value: 0 }
        ],
        subscale: 'Peer Problems'
      },
      {
        id: 's19',
        text: '19. Picked on or bullied by other children',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Peer Problems'
      },
      {
        id: 's20',
        text: '20. Gets on better with adults than with other children',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Peer Problems'
      },

      // PROSOCIAL BEHAVIOR (5 items)
      {
        id: 's21',
        text: '21. Considerate of other people\'s feelings',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Prosocial Behavior'
      },
      {
        id: 's22',
        text: '22. Shares readily with other children',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Prosocial Behavior'
      },
      {
        id: 's23',
        text: '23. Helpful if someone is hurt, upset or feeling ill',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Prosocial Behavior'
      },
      {
        id: 's24',
        text: '24. Kind to younger children',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Prosocial Behavior'
      },
      {
        id: 's25',
        text: '25. Often volunteers to help others',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Prosocial Behavior'
      }
    ],
    subscales: [
      {
        name: 'Emotional Symptoms',
        questionIds: ['s1', 's2', 's3', 's4', 's5'],
        description: 'Anxiety, depression, somatic complaints'
      },
      {
        name: 'Conduct Problems',
        questionIds: ['s6', 's7', 's8', 's9', 's10'],
        description: 'Oppositional behavior, aggression, lying'
      },
      {
        name: 'Hyperactivity',
        questionIds: ['s11', 's12', 's13', 's14', 's15'],
        description: 'Inattention, hyperactivity, impulsivity'
      },
      {
        name: 'Peer Problems',
        questionIds: ['s16', 's17', 's18', 's19', 's20'],
        description: 'Difficulties in social relationships'
      },
      {
        name: 'Prosocial Behavior',
        questionIds: ['s21', 's22', 's23', 's24', 's25'],
        description: 'Strength: empathy, cooperation, helpfulness'
      }
    ],
    interpretations: [
      { min: 0, max: 13, label: 'Normal - Low Risk', color: 'bg-green-100 text-green-800' },
      { min: 14, max: 16, label: 'Borderline - Monitor', color: 'bg-yellow-100 text-yellow-800' },
      { min: 17, max: 40, label: 'Abnormal - Evaluation Required', color: 'bg-red-200 text-red-900' }
    ]
  },
  {
    id: 'cbcl-brief',
    code: 'CBCL-25',
    name: 'Child Behavior Checklist (Ultra-Brief 25 items)',
    category: 'ADHD / Pediatric',
    description: 'Ultra-brief version of the CBCL for screening behavioral and emotional problems in children ages 6-18. Completed by parents. Assesses internalizing problems (anxiety, depression) and externalizing problems (aggression, oppositional behavior).',
    questions: [
      // INTERNALIZING PROBLEMS (12 items)
      {
        id: 'c1',
        text: '1. Acts too young for age',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },
      {
        id: 'c2',
        text: '2. Complains of loneliness',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },
      {
        id: 'c3',
        text: '3. Cries a lot',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },
      {
        id: 'c4',
        text: '4. Fears or anxieties',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },
      {
        id: 'c5',
        text: '5. Must be perfect',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },
      {
        id: 'c6',
        text: '6. Feels worthless or inferior',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },
      {
        id: 'c7',
        text: '7. Nervous, tense',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },
      {
        id: 'c8',
        text: '8. Too fearful or anxious',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },
      {
        id: 'c9',
        text: '9. Unhappy, sad or depressed',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },
      {
        id: 'c10',
        text: '10. Withdrawn, does not get involved with others',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },
      {
        id: 'c11',
        text: '11. Worries',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },
      {
        id: 'c12',
        text: '12. Somatic complaints without known medical cause',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizing'
      },

      // EXTERNALIZING PROBLEMS (13 items)
      {
        id: 'c13',
        text: '13. Argues a lot',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c14',
        text: '14. Cruelty, bullying, or meanness to others',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c15',
        text: '15. Disobedient at home',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c16',
        text: '16. Disobedient at school',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c17',
        text: '17. Gets in many fights',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c18',
        text: '18. Physically attacks people',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c19',
        text: '19. Screams a lot',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c20',
        text: '20. Talks too much',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c21',
        text: '21. Temper tantrums or hot temper',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c22',
        text: '22. Threatens people',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c23',
        text: '23. Unusually loud',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c24',
        text: '24. Destroys own things',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      },
      {
        id: 'c25',
        text: '25. Destroys things belonging to family or others',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizing'
      }
    ],
    subscales: [
      {
        name: 'Internalizing Problems',
        questionIds: ['c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'c10', 'c11', 'c12'],
        description: 'Anxiety, depression, withdrawal, somatic complaints'
      },
      {
        name: 'Externalizing Problems',
        questionIds: ['c13', 'c14', 'c15', 'c16', 'c17', 'c18', 'c19', 'c20', 'c21', 'c22', 'c23', 'c24', 'c25'],
        description: 'Aggression, oppositional behavior, disruptive conduct'
      }
    ],
    interpretations: [
      { min: 0, max: 15, label: 'Normal Range', color: 'bg-green-100 text-green-800' },
      { min: 16, max: 23, label: 'Borderline Range - Monitor', color: 'bg-yellow-100 text-yellow-800' },
      { min: 24, max: 50, label: 'Clinical Range - Evaluation Required', color: 'bg-red-200 text-red-900' }
    ]
  },
  {
    id: 'asrs-v1.1',
    code: 'ASRS',
    name: 'Adult ADHD Self-Report Scale (ASRS-v1.1) Screener',
    category: 'ADHD / Pediatric',
    description: 'A brief 6-item scale for ADHD screening in adults. Developed by WHO and Kessler et al. (2005). The first 4 items are the most predictive. Score ≥4 suggests high probability of ADHD.',
    questions: [
      {
        id: 'a1',
        text: '1. How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Inattention'
      },
      {
        id: 'a2',
        text: '2. How often do you have difficulty getting things in order when you have to do a task that requires organization?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Inattention'
      },
      {
        id: 'a3',
        text: '3. How often do you have problems remembering appointments or obligations?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Inattention'
      },
      {
        id: 'a4',
        text: '4. When you have a task that requires a lot of thought, how often do you avoid or delay getting started?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Inattention'
      },
      {
        id: 'a5',
        text: '5. How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Hyperactivity/Impulsivity'
      },
      {
        id: 'a6',
        text: '6. How often do you feel overly active and compelled to do things, like you were driven by a motor?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Hyperactivity/Impulsivity'
      }
    ],
    subscales: [
      {
        name: 'Inattention',
        questionIds: ['a1', 'a2', 'a3', 'a4'],
        description: 'Attentional and organizational difficulties (most predictive items)'
      },
      {
        name: 'Hyperactivity/Impulsivity',
        questionIds: ['a5', 'a6'],
        description: 'Motor restlessness and feeling driven by a motor'
      }
    ],
    interpretations: [
      { min: 0, max: 13, label: 'Negative Screening', color: 'bg-green-100 text-green-800' },
      { min: 14, max: 24, label: 'High Probability of ADHD - Full Evaluation Required', color: 'bg-red-200 text-red-900' }
    ]
  }
];
